import _ from '@centerhealth/common/lodash';
import { IAddress } from '@centerhealth/types';
import { Stripe, StripeCardElement, SourceResult } from '@stripe/stripe-js';
import { ICheckoutData } from '@centerhealth/common/subscribe';

/**
 * Private service used by subscribe.payment.service to create stripe source
 */
export class SubscribeSourceService {
  static createSource(
    diffBillingAddress: boolean,
    checkoutData: ICheckoutData,
    stripe: Stripe,
    card: StripeCardElement
  ): Promise<SourceResult> {
    let billingAddress: IAddress;
    const shippingAddress = {
      line1: checkoutData.line1,
      city: checkoutData.city,
      state: checkoutData.state,
      postcode: checkoutData.postcode,
      country: checkoutData.country,
    };

    // If separate billing address
    if (diffBillingAddress) {
      billingAddress = {
        line1: checkoutData.billing_line1,
        city: checkoutData.billing_city,
        state: checkoutData.billing_state,
        postcode: checkoutData.billing_postcode,
        country: checkoutData.billing_country,
      };
    } else {
      // Else use shipping address
      billingAddress = _.clone(shippingAddress);
    }
    // Create source from card so that we can charge it now as well as later
    const sourceInfo = {
      owner: {
        name: checkoutData.name,
        email: checkoutData.email,
        address: {
          line1: billingAddress.line1,
          city: billingAddress.city,
          state: billingAddress.state,
          postal_code: billingAddress.postcode,
          country: 'US',
        },
      },
    };
    return stripe.createSource(card, sourceInfo);
  }
}
